import { Order } from 'shell/view-models/order';
import { paginationListToQueryStringForBatchAndEventManager } from 'system/utils/event-batch/list-object-to-query-string-batch-event';

import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { FiltersFormEventRegistration } from './types';

export const transformDataset = (values: FiltersFormEventRegistration): string => {
  const { orders, page, rowsPerPage, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codiceSottoscrittore: {
      value: otherValues.subscriberCode,
    },
    codiceTipoDestinazione: {
      value: otherValues.destinationCode,
    },
    codiceTipoEvento: {
      value: otherValues.eventCode,
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    codiceSottoscrittore: ordersToTransform.subscriberCode,
    codiceTipoDestinazione: ordersToTransform.destinationCode,
    codiceTipoEvento: ordersToTransform.eventCode,
    descrizioneTipoEvento: ordersToTransform.eventDescription,
    descrizioneTipoDestinazione: ordersToTransform.destinationDescription,
    descrizioneSottoscrittore: ordersToTransform.subscriberDescription,
    progressivo: ordersToTransform.progressive,
  };

  return `${paginationListToQueryStringForBatchAndEventManager({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};
